export default "__VITE_ASSET__DQg5Gwes__"